import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getDashboardData,
  getBrowserViews,
  getDesktopViews,
  getMobileViews,
  getOtherViews,
  getMonthlyPlatformBreakdown,
  getHourlyPropertyViews,
  getHourlySessions,
  getAllAnalytics,
  getWorldMap,
  getKPIData,
  getConversionByDevice,
  getAppDownloads,
  getSalesConversionPath,
  getWebsiteAnalytics,
  getWebsiteMetrics,
  getAppMetrics,
  getUserTypeBreakdown
} from '../../../shared/utils/api.js'

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchDashboardData', 
  async () => {
    const response = await getDashboardData()
    return response.data
  }
)

export const fetchWorldMap = createAsyncThunk(
  'dashboard/fetchWorldMap', 
  async () => {
    const response = await getWorldMap()
    return response.data
  }
)

export const fetchBrowserViews = createAsyncThunk(
  'dashboard/fetchBrowserViews',
  async () => {
    const response = await getBrowserViews()
    return response.data
  }
)

export const fetchDesktopViews = createAsyncThunk(
  'dashboard/fetchDesktopViews',
  async () => {
    const response = await getDesktopViews()
    return response.data
  }
)

export const fetchMobileViews = createAsyncThunk(
  'dashboard/fetchMobileViews',
  async () => {
    const response = await getMobileViews()
    return response.data
  }
)

export const fetchOtherViews = createAsyncThunk(
  'dashboard/fetchOtherViews',
  async () => {
    const response = await getOtherViews()
    return response.data
  }
)

// New async thunks
export const fetchMonthlyPlatformBreakdown = createAsyncThunk(
  'dashboard/fetchMonthlyPlatformBreakdown',
  async () => {
    const response = await getMonthlyPlatformBreakdown()
    return response.data
  }
)

export const fetchHourlyPropertyViews = createAsyncThunk(
  'dashboard/fetchHourlyPropertyViews',
  async () => {
    const response = await getHourlyPropertyViews()
    return response.data
  }
)

export const fetchHourlySessions = createAsyncThunk(
  'dashboard/fetchHourlySessions',
  async () => {
    const response = await getHourlySessions()
    return response.data
  }
)

export const fetchAllAnalytics = createAsyncThunk(
  'dashboard/fetchAllAnalytics',
  async () => {
    const response = await getAllAnalytics()
    return response.data
  }
)

// KPI Actions
export const fetchKPIData = createAsyncThunk(
  'dashboard/fetchKPIData',
  async () => {
    const response = await getKPIData()
    return response.data
  }
)

export const fetchConversionByDevice = createAsyncThunk(
  'dashboard/fetchConversionByDevice',
  async () => {
    const response = await getConversionByDevice()
    // console.log(response.data)
    return response.data
  }
)

export const fetchAppDownloads = createAsyncThunk(
  'dashboard/fetchAppDownloads',
  async () => {
    const response = await getAppDownloads()
    return response.data
  }
)

export const fetchSalesConversionPath = createAsyncThunk(
  'dashboard/fetchSalesConversionPath',
  async () => {
    const response = await getSalesConversionPath()
    return response.data
  }
)

export const fetchWebsiteAnalytics = createAsyncThunk(
  'dashboard/fetchWebsiteAnalytics',
  async () => {
    const response = await getWebsiteAnalytics()
    return response.data
  }
)

export const fetchWebsiteMetrics = createAsyncThunk(
  'dashboard/fetchWebsiteMetrics',
  async () => {
    const response = await getWebsiteMetrics()
    return response.data
  }
)

export const fetchAppMetrics = createAsyncThunk(
  'dashboard/fetchAppMetrics',
  async () => {
    const response = await getAppMetrics()
    return response.data
  }
)

export const fetchUserTypeBreakdown = createAsyncThunk(
  'dashboard/fetchUserTypeBreakdown',
  async () => {
    const response = await getUserTypeBreakdown()
    return response.data
  }
)